<template>
      <div class="mfp-with-anim mfp-hide mfp-dialog clearfix" id="nav-account-dialog">
            <h3 class="widget-title">Register as Our Member</h3>
            <p>Ready to get best offers? Let's get started!</p>
            <hr />
            <form>
      
                <div class="form-group">
                <label>Category</label>
                <br>

                <div class="col-sm-6">
                  <div class="btn btn-user-type btn-block btn-lite">
                    <div class="radio">
                      <input type="radio" id="one" value="personal" v-model="category" />
                      <label for="one"> Personal</label>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="btn btn-user-type btn-block btn-secondary">
                    <div class="radio">
                      <input type="radio" id="two" value="company" v-model="category" />
                      <label for="two"> Company</label>
                    </div>
                  </div>
                </div>

                </div>
                <div class="form-group">
                    <label>Email</label>
                    <input v-model="email" class="form-control" type="text" />
                </div>
                <div class="form-group">
                    <label>Fullname</label>
                    <input v-model="name" class="form-control" type="text" />
                </div>      
                <div class="form-group">
                    <label>Phone Number</label>
                    <input v-model="mobile" class="form-control" type="text" />
                </div>                          
                <div class="form-group">
                    <label>Password</label>
                    <input v-model="password" class="form-control" type="password" />
                </div>
                <div class="form-group">
                    <label>Repeat Password</label>
                    <input v-model="confirmPassword" class="form-control" type="password" />
                </div>
                <div v-if="error != ''" class="alert alert-danger">
                    <label>{{error}}</label>
                </div>
                <!-- <div class="checkbox">
                    <label>
                        <input class="i-check" v-model="subscribe" type="checkbox" />Subscribe to the Newsletter</label>
                </div> -->
                <input class="btn btn-primary" @click.stop="onSubmit" readonly value="Register" />
            </form>
            <div class="gap gap-small"></div>
            <ul class="list-inline">
                <li>
                  <a href="#nav-login-dialog" class="popup-text">Already Member</a>
                </li>
            </ul>
        </div>
</template>

<script>

import eventBus from '@/lib/eventBus';
import { mapState } from "vuex";

export default {
  data() {
    return {
      
      email: '',
      password: '',
      confirmPassword:'',
      name:'',
      mobile: '',
      error: '',
      category: ''
    }
  },
  computed: {
 ...mapState("user", ["responseRegister"])
  },
  methods: {
    async onSubmit() { 
      if(this.email == '' || this.email == null) {
        this.error = 'Email is empty'
        return;
      }

      if(this.password == '' || this.password == null) {
        this.error = 'Password is empty'
        return;
      }

       if(this.password != this.confirmPassword) {
        this.error = 'Passwords do not match'
        return;
      }

      await this.$store.dispatch('user/register', { 
           login: this.email ,
           password: this.password,
           name: this.name,
           mobile: this.mobile,
           category: this.category
          })

      //console.log('>>>>> responseRegister : ', this.responseRegister.ReturnCode);

      if(this.responseRegister.ReturnCode == 200)
      {
      eventBus.$emit('user.registered', this.email);
      this.error == ''
      this.password = '';
      this.confirmPassword = '';
      this.name = '';
      this.mobile = '';
      this.email = '';
      this.category = '';   


      $.magnificPopup.open({
        items: {
            src: '#nav-login-dialog',
        },
        type: 'inline'
      });
      }
      else
      {
        this.error = this.responseRegister.ResponseMessage;
      }


    }
  }
}
</script>
